import React from 'react';
import back from "~/assets/images/arrow.svg";

import styled from "styled-components";
import { Link } from "react-router-dom";

const BackIcon = styled.span`
  display: flex;
  justify-content: flex-end;
  margin: 1rem 1rem 0.3rem 0;

  @media(min-width: 770px) {
    margin: 1rem 5rem 0.3rem 0;
  }
`;

export default function BackPage({ page }) {
  return(
    <Link to={page}>
      <BackIcon>
        <img src={back} alt="Ícone para voltar" />
      </BackIcon>
    </Link>
  );
}